import {
  StartApprovalIcon,
  StartDetailsIcon,
  StartRequestICon,
  StartSignIn,
} from "./icons";
import { useContent } from "../../i18n";
import "./style.scss";

export const GetStarted = () => {
  const { members } = useContent();
  const [signUp, medicalFile, request, approval] = members.steps;

  return (
    <div id="get-started" className="get-started-wrapper">
      <div className="container">
        <h2>{members.startTitle}</h2>

        <div className="start-sec row">
          <div className="start-sec-info">
            <h3>1. {signUp.t}</h3>
            <p>{signUp.d}</p>
          </div>
          <div className="sec-icon">
            <StartSignIn />
          </div>
        </div>
        <div className="start-col-wrapper">
          <div className="start-sec col">
            <div className="start-sec-info">
              <h3>2. {medicalFile.t}</h3>
              <p>{medicalFile.d}</p>
            </div>
            <div className="sec-icon">
              <StartDetailsIcon />
            </div>
          </div>

          <div className="start-sec col">
            <div className="start-sec-info">
              <h3>3. {request.t}</h3>
              <p>{request.d}</p>
            </div>
            <div className="sec-icon">
              <StartRequestICon />
            </div>
          </div>
        </div>

        <div className="start-sec row">
          <div className="start-sec-info">
            <h3>4. {approval.t}</h3>
            <p>{approval.d}</p>
          </div>
          <div className="sec-icon">
            <StartApprovalIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
